import React from "react";

import { View, Page, Text, Document, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  body: {
    paddingTop: 60,
    paddingBottom: 80,
    paddingHorizontal: 50,
    fontFamily: "openSans",
  },
  inlineImage: { width: 50 },
  hr: {
    border: "1px solid #000",
    height: 1,
    width: 150,
    color: "black",
    backgroundColor: "black",
    marginLeft: 40,
    marginTop: 70,
  },
  title: {
    paddingTop: 10,
    paddingBottom: 20,
    fontSize: 13,
    textAlign: "center",
  },
  text: {
    marginTop: 15,
    marginLeft: 40,
    marginRight: 40,
    fontSize: 10,
    textAlign: "justify",
  },
  textLessSpacing: {
    marginTop: 2,
    marginLeft: 40,
    marginRight: 40,
    fontSize: 10,
    textAlign: "justify",
  },
  textMore1Spacing: {
    marginTop: 30,
    marginLeft: 40,
    marginRight: 40,
    fontSize: 10,
    textAlign: "justify",
  },
  textMoreSpacing: {
    marginTop: 70,
    marginLeft: 40,
    marginRight: 40,
    fontSize: 10,
    textAlign: "justify",
  },
  textEvenMoreSpacing: {
    marginTop: 220,
    marginLeft: 40,
    marginRight: 40,
    fontSize: 10,
    textAlign: "justify",
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: "center",
    color: "grey",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 7,
    top: 20,
    left: 0,
    right: 0,
    paddingHorizontal: 50,
    textAlign: "center",
    color: "grey",
  },
  footer: {
    position: "absolute",
    fontSize: 7,
    bottom: 30,
    left: 0,
    right: 0,
    paddingHorizontal: 50,
    textAlign: "left",
    color: "grey",
  },
});

const Pdf = ({
  name,
  email,
  phoneNumber,
  street,
  state,
  zip,
  institute,
  webName,
  webPurpose,
  url,
  date = new Date(),
}) => (
  <Document>
    <Page size="A4" style={styles.body}>
      <Text style={styles.title}>DATA CONNECTIVITY APPLICATION</Text>
      <Text style={styles.text}>
        {" "}
        <Text
          style={{
            fontFamily: "openSans",
            fontSize: 10,
            fontStyle: "bold",
          }}
        >
          Name:{"                                      "}
        </Text>
        {name}
      </Text>
      <Text style={styles.textLessSpacing}>
        {" "}
        <Text
          style={{
            fontFamily: "openSans",
            fontSize: 10,
            fontStyle: "bold",
          }}
        >
          Email:{"                                       "}
        </Text>
        {email}
      </Text>
      <Text style={styles.textLessSpacing}>
        {" "}
        <Text
          style={{
            fontFamily: "openSans",
            fontSize: 10,
            fontStyle: "bold",
          }}
        >
          Phone Number:{"                    "}
        </Text>
        {phoneNumber}
      </Text>
      <Text style={styles.textLessSpacing}>
        {" "}
        <Text
          style={{
            fontFamily: "openSans",
            fontSize: 10,
            fontStyle: "bold",
          }}
        >
          Street Address:{"                     "}
        </Text>
        {street}
      </Text>
      <Text style={styles.textLessSpacing}>
        {"  "}
        <Text
          style={{
            fontFamily: "openSans",
            fontSize: 10,
            fontStyle: "bold",
          }}
        >
          City, State / Province:{"         "}
        </Text>
        {state}
      </Text>
      <Text style={styles.textLessSpacing}>
        {"  "}
        <Text
          style={{
            fontFamily: "openSans",
            fontSize: 10,
            fontStyle: "bold",
          }}
        >
          Country, Zip/Postal Code:{" "}
        </Text>
        {zip}
      </Text>
      <Text style={styles.text}>
        Freunde von GISAID e.V., ("
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          GISAID
        </Text>
        "), operates databases for the collection, aggregation, and sharing of
        genetic sequence data of viruses and related clinical and
        epidemiological data, including the GISAID EpiCoV™ Database (“
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          EpiCoV™ Database
        </Text>
        ”). The terms of access to and use of the GISAID Databases are governed
        by the GISAID Database Access Agreement (the "
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>DAA</Text>
        "). Each natural person who has been granted permission to access and
        use the GISAID Database(s) has agreed to be bound by the DAA.
      </Text>
      <Text style={styles.text}>
        You, {name} ("
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>You</Text>
        ”), are affiliated with {institute}. You have agreed to be bound by the
        DAA, and are an Authorized User within the meaning of the DAA.
      </Text>
      <Text style={styles.text}>
        You are applying for permission to use certain data made available
        through the GISAID EpiCoV™ Database (“
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          EpiCoV™ Data
        </Text>
        ”) in connection with the publicly accessible web application described
        below (“
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          Web Application
        </Text>
        ”), notwithstanding clause 2(b) of the DAA.
      </Text>
      <Text style={styles.text}>
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          Name of Web Application:{" "}
        </Text>
        {webName}
      </Text>
      <Text style={styles.textLessSpacing}>
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          URL of Web Application:{" "}
        </Text>
      </Text>
      <Text style={styles.textLessSpacing}>{url}</Text>
      <Text style={styles.textLessSpacing}>
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          Description of Web Application:{" "}
        </Text>
      </Text>
      <Text style={styles.textLessSpacing}>{webPurpose}</Text>
      <Text style={styles.text}>
        By signing this Application, You acknowledge that You have read and
        understand the terms of the Data Connectivity Agreement, below, and that
        You agree to those terms.
      </Text>
      <Text style={styles.text}>
        Once this Application is approved by, and the Data Connectivity
        Agreement is countersigned by, an authorized representative of GISAID,
        You will receive select EpiCoV™ Data to be used in connection with Your
        Web Application, notwithstanding clause 2(b) of the DAA.
      </Text>
      <Text style={styles.text}>
        GISAID’s provision of the Data Package will be subject to the terms of
        the Data Connectivity Agreement, below.
      </Text>
      <Text style={styles.text}>
        This{" "}
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          Data Connectivity Agreement
        </Text>
        , the terms of which are set out below, shall be deemed a supplement to
        the Database Access Agreement between GISAID and You:
      </Text>
      <Text style={styles.text}>
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          1.{"    "}DATA CONNECTIVITY
        </Text>
      </Text>
      <Text style={styles.text}>
        1.1{"    "}GISAID will provide You certain EpiCoV™ Data (the{" "}
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          “Data Package”
        </Text>
        ), to be determined by GISAID, by means of an application programming
        interface in a format defined by GISAID (the{" "}
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>“API”</Text>
        ). ”). The Data Package will be provided solely for use in connection
        with Your Web Application described above. The metadata fields
        comprising the Data Package will be determined by GISAID based on Your
        description of Your Web Application.
      </Text>
      <Text style={styles.text}>
        1.2{"    "}You acknowledge that GISAID may find it necessary to change
        the format and/or method of providing the Data Package to You. In such
        an event, GISAID will provide as much advance notice as is practicable
      </Text>
      <Text style={styles.text}>
        1.3{"    "}You will access the Data Package by means of a personalized
        username and password provided by GISAID
      </Text>
      <Text style={styles.text}>
        1.4{"    "}You agree that You will not share the username and password
        with any third parties, and that You will employ reasonable and
        appropriate security measures to prevent harm or unauthorized access to
        GISAID servers and applications.
      </Text>
      <Text style={styles.text}>
        1.5{"    "}You agree to notify GISAID of any change to your Contact
        Information provided under Section 2(f) of the DAA by email addressed to
        secretariat@gisaid.org.
      </Text>
      <Text style={styles.text}>
        1.6{"    "}You agree that You will inform GISAID as soon as practicable
        if You detect any issue or problem with the API, the delivery of the
        Data Package, or any Data in the Data Package, and will cooperate with
        GISAID to resolve any such issues or problems. You agree also that You
        will inform GISAID if, for any reason, You have stopped, or intend to
        stop, using the Data Package. GISAID will stop providing the Data
        Package on receipt of such notice, or on the date that the notice states
        You will stop using the Data Package, whichever is later. If You do not
        access the API for more than one month, GISAID will automatically stop
        providing the Data Package. You agree also that, if you stop using the
        Data Package in connection with Your Web Application, you will disable
        Your Web Application, or remove from Your Web Application any items that
        use data obtained from GISAID and any references to GISAID.
      </Text>
      <Text style={styles.text}>
        1.7{"    "}If You access the API from a computer owned by Your employer
        or laboratory, or any entity other than Yourself, You agree that You
        will inform that entity of the terms of this Data Connectivity Agreement
        (“
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          Agreement”
        </Text>
        ), and will ask the entity to ensure that, in the event that You no
        longer have access to the computer, the username and password, and any
        Data obtained from GISAID, is deleted from the computer, and GISAID is
        informed.
      </Text>
      <Text style={styles.text}>
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          2.{"    "}ADHERENCE TO THE DAA
        </Text>
      </Text>
      <Text style={styles.text}>
        2.1{"    "}Between GISAID and You, this Agreement shall be deemed a
        supplement to the DAA. You acknowledge that You are bound by the terms
        and conditions of the DAA.
      </Text>
      <Text style={styles.text}>
        2.2{"    "}You acknowledge that all EpiCoV™ Data provided to You in the
        Data Package are "Data" within the meaning of the DAA, and that the use
        of such Data is in all respects subject to the terms and conditions of
        the DAA, except as specifically provided herein. You acknowledge that
        the Data Package is being provided solely for use by You in connection
        with Your Web Application. You agree that You will not share such Data
        with any other person. You agree also that You will ensure that such
        Data cannot be accessed, downloaded, or used by any other person,
        including, without limitation, through an application programming
        interface or download functionality that serves Data obtained from
        GISAID or data with which Data obtained from GISAID can be
        reverse-engineered or reconstructed.
      </Text>
      <Text style={styles.text}>
        2.3{"    "}You acknowledge that this Agreement does not waive the terms
        of the DAA, including, without limitation, Clause 2(b) of the DAA. You
        acknowledge that this Agreement (a) does not authorize You to use any
        Data in GISAID, other than the Data in the Data Package, in connection
        with Your Web Application, and (b) does not authorize You to use the
        Data in the Data Package in connection with any web application,
        website, or database other than Your Web Application.
      </Text>
      <Text style={styles.text}>
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          3.{"    "}USE OF EPICOV™ DATA IN YOUR WEB APPLICATION
        </Text>
      </Text>
      <Text style={styles.text}>
        3.1{"    "}To avoid the introduction of bias and distorted results, you
        agree that, to prevent the addition of duplicate data, the only genetic
        sequence data that You will use in Your Web Application will be the
        EpiCoV™ Data in the Data Package provided to You.
      </Text>
      <Text style={styles.text}>
        3.2{"    "}Consistent with the ethos of the GISAID sharing mechanism, to
        ensure transparency and protect the rights of data contributors, You
        agree that You will not download and use additional metadata from the
        EpiCoV™ Database in connection with Your Web Application; if you wish to
        obtain and use additional metadata in connection with Your Web
        Application, you will contact GISAID.
      </Text>
      <Text style={styles.text}>
        3.3{"    "}GISAID is committed to using and supporting the global
        consensus nomenclature. To avoid confusion and ensure that all web
        applications that are enabled by data made available through GISAID are
        consistent in their designations of such data, you agree that You will
        use only GISAID-approved clades, lineages, and variants, and only
        GISAID-approved nomenclature for such clades, lineages, and variants, in
        connection with Your Web Application.
      </Text>
      <Text style={styles.text}>
        3.4{"    "}You agree that You will use the EpiCoV™ Data in the Data
        Package solely in connection with Your Web Application, and that You
        will not use such Data in connection with any other web application,
        website, or database, including, without limitation, by enabling others
        to download, access, or use such Data through a separate portal or
        across a network of institutions.
      </Text>
      <Text style={styles.text}>
        3.5{"    "}You agree that Your Web Application will remain publicly
        accessible without charge and will not be used for any commercial
        purpose, for profit, or monetized in any way. You agree also that You
        will not change the manner in which Your Web Application uses or
        displays EpiCoV™ Data without (a) notifying GISAID of the proposed
        changes, and (2) receiving confirmation from GISAID that such changes
        are consistent with the DAA and this Agreement.
      </Text>
      <Text style={styles.text}>
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          4.{"    "}ACKNOWLEDGEMENTS
        </Text>
      </Text>
      <Text style={styles.text}>
        4.1{"    "}You acknowledge the important role of data contributors who
        make their data available through the GISAID Initiative, and agree to
        acknowledge Your use of EpiCoV™ Data made available through GISAID by
        including the following statement in Your Web Application: “enabled by
        data from GISAID.” The statement shall include the “GISAID pill” logo in
        place of the word “GISAID,” to enable users of Your Web Application to
        recognize that You are duly authorized to use Data in GISAID in
        connection with Your Web Application. The “GISAID pill” logo will be
        provided by GISAID; it will be clickable and will link to
        https://www.gisaid.org/. The statement with the GISAID logo shall appear
        in close proximity to, and may be smaller than, Your Web Application’s
        title and/or logo.
      </Text>
      <Text style={styles.text}>
        4.2{"    "}You agree also to acknowledge the data contributors and the
        GISAID Initiative elsewhere in Your Web Application with the following
        statement: “We are grateful to the data contributors who shared the data
        used in this Web Application via the GISAID Initiative*: the Authors,
        the Originating Laboratories responsible for obtaining the specimens,
        and the Submitting Laboratories that generated the genetic sequences and
        metadata.” A footnote shall be inserted where indicated by the “*” which
        shall include a citation to (a) Elbe, S., and Buckland-Merrett, G.
        (2017) Data, disease and diplomacy: GISAID’s innovative contribution to
        global health. Global Challenges, 1:33-46. DOI: 10.1002/gch2.1018 and /
        or (b) Shu, Y., McCauley, J. (2017) GISAID: From vision to reality.
        EuroSurveillance, 22(13) DOI: 10.2807/1560-7917.ES.2017.22.13.30494.
      </Text>
      <Text style={styles.text}>
        4.3{"    "}You agree that any reference to a specific virus data entry
        in Your Web Application will provide the corresponding GISAID Accession
        Number (e.g. EPI_ISL 12345), the Originating Laboratory and Submitting
        Laboratory (as defined in DAA Section 2(c)), and the individual(s)
        listed as author(s) by the submitter of the Data. This information shall
        be displayed in a “pop-up” window or similar mechanism. To protect the
        rights of the data contributors, no sequence or additional metadata
        associated with a specific virus data entry may be displayed.
      </Text>
      <Text style={styles.text}>
        4.4{"    "}You acknowledge the WHO guidance on naming the virus that
        causes COVID-19 (found at
        https://www.who.int/emergencies/diseases/novel-coronavirus-2019/technical-guidance/naming-the-coronavirus-disease-(covid-2019)-and-the-virus-that-causes-it).
        In consideration of that guidance, You agree that any reference to
        SARS-CoV-2 in Your Web Application will be immediately followed by the
        GISAID nomenclature: “(hCoV-19)”. You acknowledge also that GISAID uses
        the WIV04 reference sequence in the processing of all genetic sequences
        made available through the GISAID EpiCoV™ Database, and You agree that
        if Your Web Application uses or refers to a common reference sequence,
        such common reference sequence shall be WIV04, as described on the
        EpiCoV™ webpage at www.gisaid.org/wiv04.
      </Text>
      <Text style={styles.text}>
        4.5{"    "}To avoid any misunderstanding on the part of persons using
        your Web Application, and to help ensure the integrity of Data obtained
        from GISAID, you agree to include the following statement in a footer on
        each page of Your Web Application: “Data used in this web application
        remain subject to GISAID’s Terms and Conditions
        http://www/gisaid/org/DAA/.”
      </Text>

      <Text style={styles.text}>
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          5.{"    "}MISCELLANEOUS
        </Text>
      </Text>
      <Text style={styles.text}>
        5.1{"    "}As indicated above, all of the terms of the DAA, as modified
        from time to time, are hereby incorporated into this Agreement and shall
        apply to this Agreement as if they were explicitly contained in this
        Agreement, except that EpiCoV™ Data provided by GISAID to You in the
        Data Package may be used by You in connection with Your Web Application.
      </Text>
      <Text style={styles.text}>
        5.2{"    "}This Agreement, including the terms of the DAA incorporated
        herein, constitutes the entire agreement between You and GISAID with
        respect to the Data Package; provided, however, that GISAID may, from
        time to time, modify this Agreement and/or the DAA, and may provide
        notice of such modifications via the Contact Information provided under
        Section 2(f) of the DAA. You agree that such notice of any such
        modification to this Agreement and/or to the DAA shall constitute
        adequate written notice of such modifications, and that You will be
        required to acknowledge and agree to any such modifications to this
        Agreement and/or to the DAA by responding to the notification and
        confirming that You accept any such modifications by such time required
        by GISAID in the notification, in order to continue to receive the Data
        Package through the API.
      </Text>
      <Text style={styles.textMore1Spacing}>
        {" "}
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          Sign Below:
        </Text>
      </Text>
      <View style={styles.hr} />
      <Text style={styles.text}>
        {name}
        {"     "}
        {date.toISOString().slice(0, 10)}
      </Text>
      <Text style={styles.textMore1Spacing}>
        <Text style={{ fontFamily: "openSans", fontStyle: "bold" }}>
          This Application must be approved by, and the Data Connectivity
          Agreement must be countersigned by, an authorized representative of
          GISAID before the Data Package will be provided.
        </Text>
      </Text>
      <Text style={styles.text}>
        <Text
          style={{
            fontFamily: "openSans",
            fontStyle: "bold",
            textAlign: "center",
          }}
        >
          DATA PACKAGE{" "}
        </Text>
      </Text>
      {/* // TODO ADd more space above for the data package. */}
      <Text style={styles.textEvenMoreSpacing}>Freunde von GISAID e.V.</Text>
      <Text style={styles.textLessSpacing}>By:</Text>
      <View style={styles.hr} />
      <Text style={styles.text}>Date:</Text>
      <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) =>
          `${pageNumber === 1 ? "" : pageNumber}`
        }
        fixed
      />
      <Text
        style={styles.footer}
        render={({ pageNumber, totalPages }) =>
          `Reproduction or redistribution of the Application and/or Data Connectivity Agreement, in whole or in part, is not permitted without express written authorization of GISAID. \n APPLICATION DCA (Research Project). 30/1/2021`
        }
        fixed
      />
    </Page>

    {/* // TODO GET SOME TEXT over to the new page */}
  </Document>
);

export default Pdf;
